<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">Contratos Repique</h3>
  </div>
  <div class="modal-body">
    <table class="table table-hover">
      <caption>O cliente possui contrato(s) apto(s) ao novo crédito!</caption>
      <thead>
        <tr>
          <td>Contrato</td>
          <td>Valor Dívida</td>
          <td>Valor Corrigido</td>
          <td>Prev. Pagto.</td>
          <td>Próximo Venc.</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let baseContrato of baseContratos">
          <td>{{baseContrato.contrato}}</td>
          <td>{{baseContrato.valores?.valorTotal | currency:'BRL':'symbol':'1.2-2'}}</td>
          <td>{{baseContrato.valores?.valorCorrigido | currency:'BRL':'symbol':'1.2-2'}}</td>
          <td>{{baseContrato.previsaoPagamento | date:'dd/MM/yyyy'}}</td>
          <td>{{baseContrato.proximoVencimento | date:'dd/MM/yyyy'}}</td>
          <td>
            <button type="button" class="btn btn-full-orange btn-select" (click)="select(baseContrato)">
              Selecionar
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="marginT30 centered">
        <button
          type="button"
          class="btn btn-border-orange"
          (click)="close()">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
